<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch01-01">
<p class="centerImage"><img alt="images" src="images/img10.jpg"/></p>
<p class="caption"><em class="italic">Map of Carlisle.</em> <span class="smallcaps">Carlisle Library</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_ch0101.vue?1f196f3e